<template>
	<div class="home-box">
		<!-- 顶部菜单 -->
		<div class="menu-bar">
			<button v-for="menu in menus" :key="menu.key" :class="{ active: activeMenu === menu.type }" @click="setActiveMenu(menu, 'click')">
			  <h2 class="button_text">{{ menu.name }}</h2>
			</button>
		</div>
		 
		<!-- <PostingModule></PostingModule> -->

		<!-- 内容显示 -->
		<div class="content-box" v-if="LoadingIcon">
			<Loading></Loading>
		</div>
		<div class="content-box messages-content-box" v-else>
			<div v-if="activeMenu === 1" class="Posts-content">
				<CommentModule :comment_list="comment_list" :parent_type="parent_type" :page_name="page_name" :follow_button="follow_button"></CommentModule>
				<Pagination v-if="search.Comment.total > 0" :per_page.sync="search.Comment.per_page" :page-sizes="pageSizes" :page.sync="search.Comment.page" :total="search.Comment.total" @pagination="get_page_Data_Comment" ></Pagination>
			</div>
			<div v-if="activeMenu === 7" class="Likes-content">
				<LikesModule :comment_list="likes_list" :parent_type="parent_type" :page_name="page_name" :follow_button="follow_button"></LikesModule>
				<Pagination v-if="search.Likes.total > 0" :per_page.sync="search.Likes.per_page" :page-sizes="pageSizes" :page.sync="search.Likes.page" :total="search.Likes.total" @pagination="get_page_Data_Likes" ></Pagination>
			</div>
			<div v-if="activeMenu === 5" class="NewFollowers-content">
			  <NewFanFollowList :Fan_Follow_List="following_list" :parent_type="parent_type" @modify_state="modify_state"></NewFanFollowList>
			  <Pagination v-if="search.NewFollowers.total > 0" :per_page.sync="search.NewFollowers.per_page" :page-sizes="pageSizes" :page.sync="search.NewFollowers.page" :total="search.NewFollowers.total" @pagination="get_page_Data_NewFollowers" ></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
import NewFanFollowList from '../components/public/NewFanFollowList.vue'
import PostingModule from '../components/public/PostingModule.vue'
import CommentModule from '../components/public/CommentModule.vue'
import LikesModule from '../components/public/LikesModule.vue'
import PostList from '../components/public/PostList.vue'
import Pagination from "@/components/Pagination"
import { post_community_userfollows, post_community_mymessages} from '@/api/community.js'
export default {
components: { CommentModule, LikesModule, PostingModule, PostList, NewFanFollowList, Pagination  },
  name: "messages",
  data() {
    return {
      menus: [
        { key: "Comment", name: this.$t('MessagesArr.Comment'), type: 1, first: true },
        { key: "Likes", name: this.$t('MessagesArr.Likes'), type: 7, first: true }, //帖子或评论点赞
        { key: "NewFollowers", name: this.$t('MessagesArr.New_Fans'), type: 5, first: true },
      ],
      activeMenu: '', // 默认选中菜单 1
		currentMenu: "",
		parent_type: "messages",
		page_name: "messages",
		search: {
			Comment: {
				type: 1,
				page: 1,
				per_page: 10,
				last_page: 0,
				total: 0,
			},
			Likes: {
				type: 7,
				page: 1,
				per_page: 10,
				last_page: 0,
				total: 0,
			},
			NewFollowers: {
				type: 5,
				page: 1,
				per_page: 10,
				last_page: 0,
				total: 0,
			},
		},
		follow_button: false,
		LoadingIcon: false,
		comment_list: [],
		likes_list: [],
		following_list: [],
		pageSizes: [10, 20, 30],
    };
  },
  
  // 监听
  	watch: {
  		// "search.user_name": {
  		// 	handler: function (newValue, oldValue) {
  		// 		if(this.search.user_name && this.search.user_name != ''){
  		// 			this.icon_search = false
  		// 		}else{
  		// 			this.icon_search = true
  		// 		}
  		// 		this.search.page = 1
  		// 		this.get_data_list()
  		// 	},
  		// 	deep: true
  		// },
  	},
  	
  	// beforeCreate() {
  		
  	// }
	
	beforeRouteLeave(to, from, next) {
		console.log('路由正在离开消息列表页面');
	   // 完成相关操作后，调用 next() 允许路由跳转
	   next();
	},
	
	// 路由返回刷新数据 // 页面激活
	activated() {
		console.log('路由进来消息列表页面成功返回');
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
		this.$setTags.updateMetaDescription("TOZO Community messages page")
	},
	
	// 页面失去激活
	deactivated() {
		
	},
  	
  	created () {
  	  
  	},
    
  	mounted() {
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
		this.$setTags.updateMetaDescription("TOZO Community messages page")
  		// this.get_type()
  	},
    
  	methods:{
		// 更新激活的菜单
		setActiveMenu(menu, click) {
			if(this.activeMenu == menu.type && click == 'click'){ return }
			this.currentMenu = menu
			this.activeMenu = menu.type;
			this.get_type(!menu.first ? 'HiddeLoading' : '')
			return menu.first = false
		},
		
		//切换类型
		get_type(typeName){
			if(!this.$store.state.userinfo.login_token){ return }
			let searchObj
			Object.keys(this.search).forEach((item, index)=>{
			console.log(item)
				if(this.activeMenu == this.search[item].type){
					searchObj = this.search[item]
				}
			})
			console.log(searchObj)
			if(this.activeMenu == 5){
				this.get_NewFollowers_list(searchObj, typeName)
			}else{
				this.get_data_list(searchObj, typeName)
			}
		},
		
		// 帖子回复获取分页
		get_page_Data_Comment(obj) {
			console.log(obj)
			if(obj.page){
				this.search.Comment.page = obj.page
			}
			if(obj.per_page){
				this.search.Comment.per_page = obj.per_page
			}
			this.get_type()
		},
		
		// 点赞获取分页
		get_page_Data_Likes(obj) {
			console.log(obj)
			if(obj.page){
				this.search.Likes.page = obj.page
			}
			if(obj.per_page){
				this.search.Likes.per_page = obj.per_page
			}
			this.get_type()
		},
		
  		// 新粉丝获取分页
  		get_page_Data_NewFollowers(obj) {
  			console.log(obj)
  			if(obj.page){
  				this.search.NewFollowers.page = obj.page
  			}
  			if(obj.per_page){
  				this.search.NewFollowers.per_page = obj.per_page
  			}
  			this.get_type()
  		},
		
  		//获取消息列表
  		get_data_list(searchObj, typeName){
  			if(this.LoadingIcon){ return }
			if(typeName != "HiddeLoading"){
				this.LoadingIcon = true
			}
  			// this.loading_completed = false
  			let obj = {
  				type: searchObj ? searchObj.type : 1, 
  				page: searchObj ? searchObj.page : 1, 
  				per_page: searchObj ? searchObj.per_page : 10,
  			}
  			console.log(obj)
  			post_community_mymessages(obj)
  		   .then((res) => {
  				console.log(res)
  				if(res.code == 0){
					this.data_processing(res)
  				}else{
  					this.exception_handling(res, userfollows)
  				}
				// this.$setTags.updateCanonical(`/messages?type=${obj.type}&page=${obj.page || 1}`)
				let path = this.$router.currentRoute.path
				this.$setTags.updateCanonical(`${path}?type=${obj.type}&page=${obj.page || 1}`)
  				// this.loading_completed = true
  		   })
  		   .catch((err) => {
  				console.log(err)
  				this.exception_handling(err)
  		   })
  		},
  		
  		//获取粉丝列表
  		get_NewFollowers_list(searchObj, typeName){
  			if(this.LoadingIcon){ return }
			if(typeName != "HiddeLoading"){
				this.LoadingIcon = true
			}
  			// this.loading_completed = false
  			let obj = {
  				user_id: this.$store.state.userinfo.user_id, 
  				page: searchObj ? searchObj.page : 1,
  				per_page: searchObj ? searchObj.per_page : 10,
  			}
  			console.log(obj)
  			post_community_userfollows(obj)
  		   .then((res) => {
  				console.log(res)
  				if(res.code == 0){
  					this.data_processing(res)
  				}else{
  					this.exception_handling(res, userfollows)
  				}
				let path = this.$router.currentRoute.path
				this.$setTags.updateCanonical(`${path}?type=${this.activeMenu}&page=${obj.page || 1}`)
				// this.$setTags.updateCanonical(`/messages?type=${this.activeMenu}&page=${obj.page || 1}`)
  				// this.loading_completed = true
  		   })
  		   .catch((err) => {
  				console.log(err)
  				this.exception_handling(err)
  		   })
  		},
		
		//数据处理
		data_processing(res){
  			this.LoadingIcon = false
			if(res && res.data){
				if(res.data.data){
					if(this.activeMenu == 1){
						this.comment_list = res.data.data
						this.search.Comment.total = res.data.total ? res.data.total : 0
						this.search.Comment.last_page = res.data.last_page ? res.data.last_page : 0
					}else if(this.activeMenu == 7){
						this.likes_list = res.data.data
						this.search.Likes.total = res.data.total ? res.data.total : 0
						this.search.Likes.last_page = res.data.last_page ? res.data.last_page : 0
					}else if(this.activeMenu == 5){
						this.following_list = res.data.data
						this.search.NewFollowers.total = res.data.total ? res.data.total : 0
						this.search.NewFollowers.last_page = res.data.last_page ? res.data.last_page : 0
					}
					console.log(this.search.Comment)
					console.log(this.search.Likes)
				}else{
					this.reset_data()
				}
			}else{
				this.reset_data()
			}
		},
  		
  		//异常处理
  		exception_handling(err, type){
			this.LoadingIcon = false
			this.reset_data()
			this.$errorMessage(err)
  			// this.$message('err.data.message', 'error')
  		},
		
		//重置数据
		reset_data(){
			if(this.search.post_type == 1){
				this.comment_list = []
				this.search.Comment.total = 0
				this.search.Comment.last_page = 0
			}else if(this.activeMenu == 7){
				this.likes_list = []
				this.search.Likes.total = 0
				this.search.Likes.last_page = 0
			}else if(this.activeMenu == 5){
				this.following_list = []
				this.search.NewFollowers.total = 0
				this.search.NewFollowers.last_page = 0
			}
		},
  		
  		//取消/关注/删除
  		modify_state(type){
  			if(type == 'success'){
				this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
  				// this.get_data_list("HiddeLoading")
  			}
  		},
  		
    }
  }
  </script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.Content-layout{
		background-color: transparent !important;
	}
	.home-box {
	  width: 100%;
	  max-width: 1280px;
	  margin: 0 auto;
	  background-color: transparent;
	}

	.menu-bar {
		margin-top: 0px;
	   display: flex;
	   justify-content: space-between;
	}

	.menu-bar button {
		border: none;
		font-size: 16px;
		cursor: pointer;
		color: #1E1E1E;
		font-weight: 600;
		width: calc(calc(100% - 20px) / 3);
		border-radius: 8px;
		background-color: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0px 10px;
	}
	.button_text{
		padding: 10px 0px;
		height: 100%;
		flex:  0 0 auto;
		font-size: 16px;
		border-bottom: 2px solid #ffffff;
	}

	.menu-bar button.active .button_text {
	  border-bottom: 2px solid #000000;
	}

	.content-box {
	  margin-top: 10px;
	}

	.Posts-content,
	.Likes-content,
	.NewFollowers-content{
	  /* background-color: #f9f9f9; */
	  border-radius: 8px;
	}
	.messages-content-box .pagination-container{
	  margin-top: 10px;
	  border-radius: 8px;
	}
</style>
